import React, { useState } from 'react';
import './ArticleQA.css';

/**
 * ArticleQA Component
 * Q&A section for help articles where users can see and contribute answers
 */
const ArticleQA = ({ articleId }) => {
  const [questions, setQuestions] = useState([
    {
      id: 1,
      question: 'How do I invite friends to a split?',
      author: 'John D.',
      date: '2 days ago',
      answers: [
        {
          id: 1,
          answer: 'You can invite friends by clicking the "Add Participants" button when creating a split, or by sharing the split link directly.',
          author: 'Sarah M.',
          date: '1 day ago',
          helpful: 5
        }
      ]
    },
    {
      id: 2,
      question: 'Can I split expenses unevenly?',
      author: 'Mike T.',
      date: '5 days ago',
      answers: [
        {
          id: 1,
          answer: 'Yes! When creating a split, you can choose custom amounts for each participant instead of splitting equally.',
          author: 'Emma L.',
          date: '4 days ago',
          helpful: 12
        },
        {
          id: 2,
          answer: 'You can also use percentages if that works better for your situation.',
          author: 'Alex P.',
          date: '3 days ago',
          helpful: 8
        }
      ]
    }
  ]);

  const [newQuestion, setNewQuestion] = useState('');
  const [showQuestionForm, setShowQuestionForm] = useState(false);

  const handleSubmitQuestion = (e) => {
    e.preventDefault();
    if (newQuestion.trim()) {
      const question = {
        id: questions.length + 1,
        question: newQuestion,
        author: 'You',
        date: 'Just now',
        answers: []
      };
      setQuestions([question, ...questions]);
      setNewQuestion('');
      setShowQuestionForm(false);
    }
  };

  return (
    <section className="article-qa">
      <div className="article-qa-header">
        <h2 className="article-qa-title">Questions & Answers</h2>
        <p className="article-qa-subtitle">
          Have a question? Ask the community or browse answers from other users.
        </p>
      </div>

      <div className="article-qa-actions">
        <button
          className="article-qa-ask-button"
          onClick={() => setShowQuestionForm(!showQuestionForm)}
        >
          Ask a Question
        </button>
      </div>

      {showQuestionForm && (
        <form className="article-qa-form" onSubmit={handleSubmitQuestion}>
          <textarea
            className="article-qa-input"
            placeholder="What would you like to know?"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
            rows={4}
          />
          <div className="article-qa-form-actions">
            <button type="submit" className="article-qa-submit-button">
              Post Question
            </button>
            <button
              type="button"
              className="article-qa-cancel-button"
              onClick={() => {
                setShowQuestionForm(false);
                setNewQuestion('');
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      <div className="article-qa-list">
        {questions.length === 0 ? (
          <p className="article-qa-empty">No questions yet. Be the first to ask!</p>
        ) : (
          questions.map((q) => (
            <div key={q.id} className="article-qa-item">
              <div className="article-qa-question">
                <h3 className="article-qa-question-text">{q.question}</h3>
                <div className="article-qa-meta">
                  <span className="article-qa-author">{q.author}</span>
                  <span className="article-qa-date">{q.date}</span>
                </div>
              </div>

              {q.answers.length > 0 && (
                <div className="article-qa-answers">
                  {q.answers.map((answer) => (
                    <div key={answer.id} className="article-qa-answer">
                      <p className="article-qa-answer-text">{answer.answer}</p>
                      <div className="article-qa-answer-footer">
                        <div className="article-qa-answer-meta">
                          <span className="article-qa-author">{answer.author}</span>
                          <span className="article-qa-date">{answer.date}</span>
                        </div>
                        <button className="article-qa-helpful-button">
                          Helpful ({answer.helpful})
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <button className="article-qa-answer-button">
                {q.answers.length === 0 ? 'Be the first to answer' : 'Add an answer'}
              </button>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default ArticleQA;
